import { typeChoices } from '../../../http/api/UserApi';
import { useEffect, useState } from 'react';

const useTypeItems = ( ) => {
  const [typeList, setTypeList] = useState([]);
  useEffect(() => {
    fetchTypeChoices();
  }, []);

  const fetchTypeChoices = async () => {
    const type = await typeChoices();
    setTypeList(type.typeChoicesInfo);
  };

  return typeList;
};

export default useTypeItems;
